import { CheckNotes, InspectionCase } from '../../inspection-cases';

export class ElectricShutdownPumpDto extends InspectionCase {
  pumpRotation?: InspectionCase;
  pumpWaterSupply?: InspectionCase;
}

export class ElectricShutdownPump extends ElectricShutdownPumpDto {
  constructor(data: ElectricShutdownPumpDto = { title: 'משאבת כיבוי חשמלית' }) {
    super(data);
    this.pumpRotation = new InspectionCase({
      ...data.pumpRotation,
      title: `המשאבה מסתובבת בכיוון הנכון`
    });
    this.pumpWaterSupply = new InspectionCase({
      ...data.pumpWaterSupply,
      title: `אספקת המים למשאבה ,ממאגר המים או רשת עירונית ציין`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.pumpRotation.isApplicable || this.pumpRotation.isPassed) &&
        (!this.pumpWaterSupply.isApplicable || this.pumpWaterSupply.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.pumpRotation.getNotes(),
      ...this.pumpWaterSupply.getNotes()
    ];
  }
}
